module.exports = "<app-report-modal2 [commonData]= 'gridView' [report]='reportName'></app-report-modal2>"